module.exports = __webpack_public_path__ + "media/images/meta/stretchlab_aus/favicon_alt-0e4a76becd19bff6c90b54009770f5c2.png";